import { ZIndexes } from "@glossy";
import Intercom from "@intercom/messenger-js-sdk";
import { useFeature } from "@radarly/core/features/use-cases";
import { User } from "@radarly/models/user";

export const useInitIntercom = (user: User) => {
  const isIntercomMessengerEnabled = useFeature("intercom_messenger");

  if (!isIntercomMessengerEnabled) {
    return;
  }

  Intercom({
    app_id: "nrrln6l2",
    z_index: ZIndexes.Panel - 1,
    user_id: String(user.id),
    name: user.name,
    email: user.email,
    created_at: Math.trunc(new Date(user.created).getTime() / 1000), // User's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200

    horizontal_padding: 15, // Fallback for dev/staging, the value is set in the Intercom settings
    vertical_padding: 25, // Fallback for dev/staging, the value is set in the Intercom settings
  });
};
